<div class="layout-topbar" [class.no-left-bar]="layoutService.layoutState().staticMenuDesktopInactive">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
        </a>
    </div>

    <div class="layout-topbar-menu-wrapper">
        <p-menubar [model]="items"></p-menubar>
        <div class="option-menu-mobile">
            <p-menu #optionMenu [model]="items" [popup]="true" [appendTo]="'body'" />
            <p-button (click)="optionMenu.toggle($event)" icon="pi pi-ellipsis-v" label="Info" />
        </div>
        <div class="ml-auto option-menu-mobile">
            @if(isLoggedIn()){
            <p-menu #menu [model]="profileMenu" [popup]="true" [appendTo]="'body'" />
            <button type="button" (click)="menu.toggle($event)">
                <p-avatar [label]="getUserInitials()" shape="circle" />
            </button>
            }
        </div>

    </div>

    <div class="layout-topbar-actions">
        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                @if(isLoggedIn()){
                <p-menu #menu [model]="profileMenu" [popup]="true" [appendTo]="'body'" />
                <button type="button" (click)="menu.toggle($event)">
                    <p-avatar [label]="getUserInitials()" shape="circle" />
                </button>
                }
            </div>
        </div>
    </div>
</div>